import React from 'react';
import ReactDOM from 'react-dom/client';
import config from './Config';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { AppContext, ModalsContext } from './contexts/AppContext';
import { Utils } from './Utils';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Az App komponens ref-je
const appRef = new React.createRef();


// Modal referenciák - itt fontos a sorrend mert a visszagomb megnyomására mindig az itt leírt sorrendben az első látható modalt zárjuk be
const modalsRefs = {
  CheckoutSummaryRef: React.createRef(), // Megrendelés összesítő
  PopupAddedToCartRef: React.createRef(),
  PopupContentRef: React.createRef(),
  ShoppingCartRef: React.createRef(),
  ProductsMenuRef: React.createRef(),
  MyOrdersRef: React.createRef(),
  MyOrdersRef_2: React.createRef(),
  MyMessagesRef: React.createRef(),
  MyMessagesRef_2: React.createRef(),
  ProfileMenuRef: React.createRef(),
  WishlistRef: React.createRef(),
  RoyaltyCardRef: React.createRef(),
  AppDiscountsRef: React.createRef(),
  AppDiscountsRef_2: React.createRef(),
  ProfileBillAddressRef: React.createRef(),
  ProfileDeliveryAddressesRef: React.createRef(),
  ProfilePersonalDatasRef: React.createRef(),
  ProfileRef: React.createRef(),
  ShopsRef: React.createRef(),
  SignInRef: React.createRef(),
  //ProfilePaymentMethodRef: React.createRef(),
  AppHeaderRef: React.createRef(),
  AppFooterMenuRef: React.createRef(),
};

/*
// Egyéb referenciák
const otherRefs = {
  
};
*/

const appContextValue = { appRef };

Utils.setAppContext(appContextValue);
Utils.setModalsContext(modalsRefs);

root.render(
  <React.StrictMode>
    <AppContext.Provider value={appContextValue}>
      <ModalsContext.Provider value={modalsRefs}>
        <App ref={appRef} />
      </ModalsContext.Provider>
    </AppContext.Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register(config);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
